import React from 'react';
import { Helmet } from 'react-helmet-async';

const DisclaimerPage = () => {
  return (
    <div className="min-h-screen pt-24 page-bg-shell page-bg-grid" data-testid="disclaimer-page">
      <Helmet>
        <title>Disclaimer | Wowrolla</title>
        <meta name="description" content="Wowrolla legal disclaimer for informational content, affiliate links, and no-professional-advice terms." />
      </Helmet>

      <section className="container mx-auto px-6 pb-14 max-w-4xl">
        <h1 className="text-4xl font-black mb-6" style={{ color: 'var(--text-primary)', fontFamily: 'Unbounded, sans-serif' }}>
          Disclaimer
        </h1>

        <div className="terminal-grid p-6 space-y-4" style={{ color: 'var(--text-secondary)' }}>
          <p>
            The information on Wowrolla is provided for general informational purposes only. While we strive for accuracy,
            no representation or warranty is made regarding completeness, reliability, or suitability for your specific use case.
          </p>

          <div className="border border-yellow-500/30 bg-yellow-500/5 rounded p-3 text-sm space-y-2">
            <p className="font-semibold" style={{ color: 'var(--text-primary)' }}>🍁 Affiliate Disclosure — Competition Bureau of Canada</p>
            <p>
              Wowrolla earns affiliate commissions on some tool links. This constitutes a material connection between Wowrolla
              and the tool providers. Disclosure is made in our footer, on every tool page, and on our{' '}
              <a href="/transparency" className="underline hover:text-cyber-yellow">Transparency page</a> in accordance with
              the <em>Competition Act</em> (Canada) and the Competition Bureau's deceptive marketing practices guidelines.
              Commissions do not influence editorial rankings or recommendations.
            </p>
          </div>

          <div className="border border-blue-500/30 bg-blue-500/5 rounded p-3 text-sm space-y-2">
            <p className="font-semibold" style={{ color: 'var(--text-primary)' }}>🇨🇦 Canadian Jurisdiction &amp; Data Hosting</p>
            <p>
              Wowrolla is operated from Ottawa, Ontario, Canada and is subject to Canadian federal law including PIPEDA,
              the Competition Act, and CASL. Quebec residents also have rights under Quebec Law 25.
              Data is hosted in Canada by a third-party cloud provider. Our hosting provider may be incorporated in the
              US and subject to the US CLOUD Act — see our{' '}
              <a href="/privacy-policy" className="underline hover:text-cyber-yellow">Privacy Policy</a> for full disclosure.
            </p>
          </div>

          <p>
            Content on this site does not constitute legal, financial, tax, accounting, security, or professional advice.
            You should consult qualified professionals before making material decisions.
          </p>
          <p>
            Third-party products and services referenced on Wowrolla are owned and operated by their respective providers.
            We are not responsible for third-party availability, performance, claims, or content.
          </p>
          <p>
            Use of Wowrolla is at your own risk. To the extent permitted by applicable Canadian law, Wowrolla disclaims
            liability for direct, indirect, incidental, or consequential damages arising from use of this website.
          </p>
        </div>
      </section>
    </div>
  );
};

export default DisclaimerPage;

